import { OrdersStreamRepository } from '../../domain/repositories/OrdersStreamRepository'
import getSignalRConnection from '@/utils/signalRConnection'
import { HubConnection } from '@microsoft/signalr'
import { OrdersStreamEntity } from '../../domain/entities/OrdersStreamEntity'
import { OrdersStreamModel } from '../models/OrdersStreamModel'
import { OrderStreamFilterModel } from '../models/OrderStreamFilterModel'
import { OrderMiniModel } from '@/features/order/data/models/OrderMiniModel'
import { OrdersService } from '@/backend/market'
import type { OrderStreamFilterEntity } from '../../domain/entities/OrderStreamFilterEntity'

export class OrdersStreamRepositoryImpl implements OrdersStreamRepository {
  private connection: HubConnection | null = null

  async connect(): Promise<void> {
    this.connection = getSignalRConnection()
    if (this.connection.state !== 'Connected') {
      // await this.connection.start()
    }
  }

  disconnect(): void {
    this.connection?.stop()
  }

  onOrderUpdate(callback: (value: string) => void): void {
    this.connection?.on('OrderUpdate', callback)
  }

  onOrderErase(callback: (value: string) => void): void {
    this.connection?.on('EraseOrder', callback)
  }

  async getOrdersStream(): Promise<OrdersStreamEntity | 'error'> {
    try {
      await this.connect()
      return new OrdersStreamEntity()
    } catch {
      return 'error'
    }
  }

  async getMonitoringOrdersStream(
    filter: OrderStreamFilterEntity
  ): Promise<OrdersStreamEntity | { error: true }> {
    try {
      const orderStreamFilterModel = new OrderStreamFilterModel(filter)
      const response = await OrdersService.getStreamOrdersAdmin(orderStreamFilterModel)

      const orderModels = response.orders
        ?.map((data) => new OrderMiniModel(data as OrderMiniModel))
        ?.sort((a, b) => {
          const dateA = new Date(a.createdAt || 0).getTime()
          const dateB = new Date(b.createdAt || 0).getTime()
          return dateB - dateA
        })

      return new OrdersStreamModel({
        showCompletedOrderDurationInSecond: response.showCompletedOrderDurationInSecond ?? 0,
        showCanceledOrderDurationInSecond: response.showCanceledOrderDurationInSecond ?? 0,
        orders: orderModels || []
      })
    } catch {
      return { error: true }
    }
  }
}
export default OrdersStreamRepositoryImpl
